__webpack_require__.p = "/mi-assets/mi-static/mi-legal-renderer/web-rel-26.5.1-df956df-9504/_next/";